import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './payment-gateway-modal.css';
import monday from './pictures/momo.png';
import money from './pictures/Money.png';
import Ben from './pictures/ben.png';
import koko from './pictures/koko.png';
import api from '../../../../service/caller.js'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';



const PaymentGatewayModal = ({ onClose, billing, amountToPay }) => {
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [phone, setPhoneNumber] = useState('');
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [paymentdetails, setPaymentdetails] = useState('');
  const navigate = useNavigate();



  const handlePaymentMethodSelect = (method) => {
    setPaymentMethod(method);
  };

  const handleConfirmPayment = () => {
    if ((paymentMethod === 'mobile-money' && phone) || paymentMethod === 'card') {
      setPaymentStatus('success');
    }
  };


  // Paybymomo
  const handleMomoPaymentConfirmation = async () => {
    const billingID = billing._id;
  
    // Vérifier si paymentMethod est sélectionné et si le téléphone est renseigné pour 'mobile-money'
    if (!paymentMethod) {
      toast.error('Please select a payment method.');
      return;
    }
  
    if (paymentMethod === 'mobile-money' && !phone) {
      toast.error('Please enter your phone number.');
      return;
    }
  
    // Préparation des données de paiement
    const paymentData = {
      item_name: 'Billing Payment',
      amount: amountToPay, // Récupérer le prix de l'abonnement
      currency: 'USD',
      phoneNumber: phone,
      payerMessage: billing.purpose,
      paymentReason: 'Payment for this billing',
      motifId: billingID,
    };
  
    try {
      // Soumettre les données au backend pour générer le lien de redirection PayPal
      const paymentResponse = await api.post(`/payment/paymentmomo/initiate`, paymentData);
  
      if (paymentResponse?.status === 200) {
        setPaymentdetails(paymentResponse.data.payment);
        const paymentstatus = true;
        const currency = paymentData.currency;
        setPaymentStatus('success');
        await api.put(`clinic/billing/updatepaystatus/${billingID}`, { paymentstatus: paymentstatus, paymentMethod, currency });
      } else {
        toast.error("Payment failed!");
      }
    } catch (error) {
      console.error('Erreur lors du paiement:', error);
      toast.error(`Payment failed: ${error?.message}. Please try again.`);
    }
  };
  

  const handleValidate = () => {
    // Rediriger vers la page des patients
    navigate('/Billings/allpaymentlist');
  };

  const handleDownload = async () => {
    const element = document.querySelector('.recu');
    if (!element) return;

    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff'
      });

      const imgData = canvas.toDataURL('image/jpeg', 1.0);
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      const imgWidth = 210; // A4 width
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
      pdf.save(`${billing.paymentuniqueId}_recupayement.pdf`);
    } catch (error) {
      console.error('Erreur de génération PDF:', error);
    }
  };


  if (paymentStatus === 'success') {
    return (
      <>
        <div className="payment-gateway-success-modal">
          <div className="payment-gateway-success-content">
            <div className='range'>
              <button
                className="sucess-gateway-modal-close"
                onClick={onClose}
              >
                ← Retour
              </button>
            </div>
            <div>
              <h2 className='sagbo'>Successful payment</h2>
              <p>Votre paiement a été effectué avec succès.</p>
              <img src={Ben} alt="Ben" className="Ben" />
            </div>
            <div>
              <button onClick={() => setShowTicketModal(true)} className='woro'> Voir la Facture</button>
            </div>
          </div>
        </div>

        {showTicketModal && (
          <div className="ticket-modal-overlay">
            <div className="ticket-modal-content">
              {/* <button className="ticket-modal-close" onClick={onClose}>✕</button> */}
              <div className="modal-container">
                <div className="modal-header3">
                  <h3>Recu Medical</h3>
                </div>
                <div className="recu">
                  <div className="receipt-header">
                    <div className="logoi">
                      <img src={koko} alt="koko" className="koko" />
                    </div>
                    <div className="title">
                      <p>RECU DE <br></br> PAIEMENT</p>
                    </div>
                  </div>
                  <div className="receipt-id">
                    <span>Receipt ID</span>
                    <div>{billing.paymentuniqueId}</div>
                  </div>

                  <div className="receipt-datetime">
                    <div className="date">
                      <p><strong>Date: </strong>Sun, Mar 27, 2024</p>
                      <p><strong>Time:</strong> 5:37:22 AM</p>
                    </div>
                    <div className="timeler">
                      <p><strong>Name:</strong> SOH-SOH Jacquot</p>
                    </div>
                  </div>
                  <div className='ici'>
                    <p className='vies'>Services</p>
                    <p className='vies'>Prix</p>
                  </div>
                  <div className="service-item">
                    <span>Consultation Gynécologique</span>
                    <span>{billing.amount} XOF</span>
                  </div>
                  <div className="receipt-content">

                    <div className="amount">
                      <span>Amount</span>
                      <span>{billing.amount} XOF</span>
                    </div>
                    <div className="tax">
                      <span>Tax</span>
                      <span>0 XOF</span>
                    </div>
                    <div className="total">
                      <span>Total</span>
                      <span>{billing.amount} X0F</span>
                    </div>
                  </div>
                  <div className='gagn'>
                    <p>Payé </p>
                    <p>{paymentdetails.amount}</p>
                  </div>

                  <div className="payment-info">
                    <div>Payment by: <strong>Mobile Money</strong></div>
                    <div className="reference">Reference No: {phone}</div>
                    <div>Statut: Payed</div>
                  </div>

                  <div className="receipt-footer">
                    <p>
                      Le reçu fait office de justificatif <br></br>
                      de paiement. Veuillez le conserver.
                    </p>
                    <p className='atroce'>SIGNATURE</p>
                  </div>
                </div>
                <div className='separate'>
                  <button className='auto' onClick={handleValidate}>Envoyer au patient</button>
                  <button className='rite' onClick={handleDownload}  >Imprimer le recu</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  return (
    <>
      <div className="payment-gateway-modal-overlay">
        <div className="payment-gateway-modal-content">
          <div className='modal-header1'>
            <h5>Payement</h5>
          </div>
          <ToastContainer />
          <div className='ret'>
            <button
              className="payment-gateway-modal-close"
              onClick={onClose}
            >
              ← Retour
            </button>

            <div className='paycontent'>
              <h2 className='pinta'>Choisissez votre méthode de paiement</h2>
              <div className="payment-method-selection">
                <label className="payment-method-radio">
                  <input
                    type="radio"
                    name="payment-method"
                    value="mobile-money"
                    checked={paymentMethod === 'mobile-money'}
                    onChange={() => handlePaymentMethodSelect('mobile-money')}
                  />
                  <img src={monday} alt="monday" className="monday" />
                </label>
                <label className="payment-method-radio">
                  <input
                    type="radio"
                    name="payment-method"
                    value="card"
                    checked={paymentMethod === 'card'}
                    onChange={() => handlePaymentMethodSelect('card')}
                  />
                  <img src={money} alt="money" className="money" />
                </label>
              </div>

              {paymentMethod === 'mobile-money' && (
                <div className="phone-input-container mobile-money-input">
                  <label>Enter your phone number</label>
                  <PhoneInput
                    country={'bj'}
                    value={phone}
                    onChange={(value) => setPhoneNumber(value)} // Prendre directement la valeur
                    name="phone"
                    className="mx-auto"
                  />
                </div>
              )}
              <div className='aladji'>
                <button
                  onClick={handleMomoPaymentConfirmation}
                  disabled={paymentMethod === 'mobile-money' && !phone}
                  className="payment-confirm-button"
                >
                  Confirmer le Paiement
                </button>
                <p className='vonvon'>Your personal data will be used to process your  order, support your <br></br> experience throughout this website, and for other purposes described  <br></br>in our privacy policy.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* {showTicketModal && (
        <div className="ticket-modal-overlay">
          <div className="ticket-modal-content">
            <button className="ticket-modal-close" onClick={() => setShowTicketModal(false)}>✕</button>
            <h2>Votre Ticket</h2>
            <p>Détails de votre paiement et accès.</p>
          </div>
        </div>
      )} */}
    </>
  );
};

export default PaymentGatewayModal;
